import classNames from 'classnames';
import { FC } from 'react';

import { TLanguage } from '@lib/core/retailers/types';
import { useApp } from '@lib/core/service/hooks';

interface Props {
  supportedLanguages: TLanguage[];
  className?: string;
}

export const LanguageSwitcherComponent: FC<Props> = ({ supportedLanguages, className }) => {
  const { handleSetServiceLocale, locale } = useApp();

  const onLanguageSelect = code => {
    handleSetServiceLocale(code);
  };

  return (
    <div className={classNames('taste-advisor-language-switcher', className)}>
      {supportedLanguages.length > 1
        ? supportedLanguages.map(({ code, language }) => (
            <button
              key={code}
              className={classNames('pointer switcher-btn ta-start-page-language-switcher', {
                'font-weight-bold': locale === code,
              })}
              onClick={() => onLanguageSelect(code)}
            >
              {language}
            </button>
          ))
        : null}
    </div>
  );
};
